import React from "react";
import { motion } from "framer-motion";
import { DoxMascot } from "@/components/Logo";
import { Reveal } from "./Reveal";

const STATS = [
  { value: "24/7", label: "Always on duty" },
  { value: "0", label: "Invented requirements" },
  { value: "100%", label: "Documents remembered" },
];

export default function MeetDox() {
  return (
    <section id="meet-dox" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="glow-orb w-[500px] h-[500px] -left-40 top-20 bg-dox-purple/15" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-dox-magenta mb-5">Meet DOX</div>
          <h2 className="font-display font-black tracking-tight text-4xl sm:text-6xl leading-[0.98]">
            Not software.<br />
            <span className="text-gradient-brand">An employee.</span>
          </h2>
          <p className="mt-7 text-lg text-white/60 leading-relaxed max-w-xl">
            DOX is your AI Compliance Employee. It doesn’t wait for you to click around a dashboard —
            it does the administrative and compliance work contractors hate. You hand it your paperwork.
            It reviews, organizes, remembers and keeps you compliant.
          </p>
          <p className="mt-5 text-lg text-white/60 leading-relaxed max-w-xl">
            And DOX plays by the rules: it never fabricates government requirements, fees or deadlines.
            Every recommendation comes with a <span className="text-white font-semibold">confidence level</span> and
            <span className="text-white font-semibold"> source attribution</span>.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-xl border border-white/10 bg-surface p-4">
                <div className="font-display font-black text-3xl text-gradient-brand">{s.value}</div>
                <div className="text-xs text-white/45 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative flex items-center justify-center">
            <div className="absolute inset-0 bg-gradient-to-tr from-dox-orange/20 via-dox-magenta/20 to-dox-purple/20 blur-3xl rounded-full" />
            <motion.div
              animate={{ y: [0, -16, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              className="relative glass-strong rounded-3xl border border-white/10 p-12"
            >
              <DoxMascot size={220} />
              <div className="mt-6 text-center">
                <div className="font-display font-black text-2xl">Hi, I’m DOX.</div>
                <div className="text-sm text-white/50 mt-1">I’ll take the paperwork from here.</div>
              </div>
            </motion.div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
